<template>
  <div class="text-center">
    <v-dialog
      v-model="showLoadingDialog"
      transition="scroll-x-transition"
      persistent
      width="300"
    >
      <v-card
        color="rgb(0,0,0,0.8)"
        dark
      >
        <v-card-text>
          {{loadingDialogMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            height="5"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
  export default {

  computed:{
      ...mapGetters({
          showLoadingDialog: 'dialogModule/getShowLoadingDialog',
          loadingDialogMessage: 'dialogModule/getLoadingDialogMessage'
      })
  }
 }
</script>